@defer {
  <div>
    <app-form-prefix [field]="startField" (onchange)="onFieldChange()" />
    <app-form-prefix [field]="endField" (onchange)="onFieldChange()" />
  </div>
}
